import { j as json, e as error } from "../../../../chunks/index2.js";
import admin from "firebase-admin";
import { randomUUID } from "crypto";
import { a as sendEmailVerification } from "../../../../chunks/mailer.js";
import { h as handleRequest } from "../../../../chunks/utils.js";
const GET = handleRequest(async ({ url, locals }) => {
  const { searchParams } = url;
  const email = searchParams.get("email");
  const code = searchParams.get("code");
  if (email && code) {
    const verificationCode = await admin.firestore().collection("verificationCodes").doc(email).get();
    if (verificationCode.exists) {
      const verified = verificationCode.data()?.code === code;
      if (verified) {
        await verificationCode.ref.delete();
        const userRef = admin.firestore().collection("users").doc(locals.user?.id);
        await userRef.set({ email }, { merge: true });
      }
      return json({ verified }, { status: verified ? 200 : 403 });
    }
    return error(404, {
      message: "Verification code not found"
    });
  }
  if (email) {
    const id = randomUUID().split("-").join("");
    const code2 = id.substring(0, 6).toUpperCase();
    const docRef = admin.firestore().collection("verificationCodes").doc(email);
    await docRef.set({ code: code2 });
    await sendEmailVerification(email, code2);
    return json({ success: true });
  }
  return error(400, {
    message: "No email provided"
  });
});
export {
  GET
};
